import { render } from "./HomeLite.vue?vue&type=template&id=633ebd36"
import script from "./HomeLite.vue?vue&type=script&lang=js"
export * from "./HomeLite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__